import { SlugInputField } from './SlugInputField'
import { withSlugInputField } from './withSlugInputField'

const ConnectedSlugInputField = withSlugInputField(SlugInputField)

export { ConnectedSlugInputField as SlugInputField }
